module.exports = __webpack_public_path__ + "static/media/sort.7207b7a4.svg";